function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var BuildOverlayTemplate = require('./build.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var BuildOverlay = /*#__PURE__*/function () {
  function BuildOverlay(app, mod) {
    _classCallCheck(this, BuildOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(this.app, this.mod, false);
  }
  return _createClass(BuildOverlay, [{
    key: "render",
    value: function render() {
      this.overlay.show(BuildOverlayTemplate(this.app, this.mod, this));
      this.attachEvents();
    }
  }, {
    key: "checkAndReturnResource",
    value: function checkAndReturnResource(resource, resource_count) {
      var track_resource = [];
      var player = this.mod.game.player;
      var myBank = this.mod.game.state.players[player - 1].resources.slice();
      for (var i = 0; i < myBank.length; i++) {
        if (myBank[i] == resource) {
          track_resource.push(myBank[i]);
        }
      }
      var html = "";
      for (var _i = 0; _i < resource_count; _i++) {
        if (track_resource.length > 0) {
          html += this.returnCardImg(resource, false);
          track_resource.shift();
        } else {
          html += this.returnCardImg(resource, true);
        }
      }
      return html;
    }
  }, {
    key: "returnCardImg",
    value: function returnCardImg(resource) {
      var disabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return "<img class=\"".concat(disabled ? "settlers-card-disabled" : "", "\" src=\"/settlers/img/cards/").concat(resource, ".png\">");
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var this_self = this;
      document.querySelectorAll('.settlers-item-row').forEach(function (item) {
        item.onclick = function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          var id = e.currentTarget.getAttribute('id');
          var disabled = e.currentTarget.classList.contains('settlers-row-disabled');
          if (!disabled) {
            this_self.overlay.close();
            document.querySelectorAll('.settlers-item-row').forEach(function (row) {
              row.onclick = function (e) {};
            });
            if (id === '0') {
              this_self.mod.addMove("player_build_road\t".concat(this_self.mod.game.player, "\t0\t1"));
            }
            if (id === '1') {
              this_self.mod.addMove("player_build_city\t".concat(this_self.mod.game.player, "\t1"));
            }
            if (id === '2') {
              this_self.mod.addMove('player_upgrade_city\t' + this_self.mod.game.player);
            }
            if (id === '3') {
              //have everyone update game state
              this_self.mod.addMove('buy_card\t' + this_self.mod.game.player);
              // Deck #1 = deck[0] = devcard deck
              //get card from deck
              this_self.mod.addMove('SAFEDEAL\t1\t' + this_self.mod.game.player + '\t1');
              this_self.mod.game.status = 'decrypting action card';
              this_self.mod.hud.updateStatus(this_self.mod.game.status);
              this_self.mod.hud.updateMenu([]);
              this_self.mod.hud.updateCards([]);
              this_self.mod.animateDevCard(this_self.mod.game.player);
            }
            var purchase = parseInt(id);
            if (purchase >= 0 && purchase <= 3) {
              var cost = this_self.mod.priceList[purchase];
              var _iterator = _createForOfIteratorHelper(cost),
                _step;
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var resource = _step.value;
                  //Put the spends on the front of the move, so we can maybe cancel the building action
                  this_self.mod.addMove('spend_resource\t' + this_self.mod.game.player + '\t' + resource);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              this_self.mod.endTurn();
            } else {
              //console.log("Unexpected selection for player move:",id);
            }
          }
        };
      });
    }
  }]);
}();
module.exports = BuildOverlay;